import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Section, Container, t, BtnWhite, BtnOutlineWhite } from '../styles/shared';
import { resolveMediaServeUrl } from '../utils/mediaServeUrls';

const Content = styled.div`
  max-width: 800px;
  ${({ $align }) => $align === 'center' && 'margin: 0 auto;'}
`;

const Headline = styled.h2`
  margin: 0 0 16px 0; font-family: ${t.fontHeading};
  font-size: 2.5rem; font-weight: 600;
  @media (max-width: 1024px) { font-size: 2rem; }
  @media (max-width: 768px)  { font-size: 1.75rem; }
`;

const Sub = styled.p`
  margin: 0 0 32px 0; font-size: 1.25rem; opacity: 0.95;
`;

const Buttons = styled.div`
  display: flex; gap: 16px; flex-wrap: wrap;
  ${({ $center }) => $center && 'justify-content: center;'}
`;

const isExt = (u) => u?.startsWith('http://') || u?.startsWith('https://');

const CTABlock = ({ content = {}, settings = {}, tenantSlug, apiBase }) => {
  const {
    headline = '', subheadline = '', alignment = 'center',
    padding: cp = 'large',
    button = {}, secondaryButton = {},
    // flat-key fallbacks for legacy content
    buttonText = '', buttonLink = '',
    secondaryButtonText = '', secondaryButtonLink = ''
  } = content;

  const primaryText = button.text || buttonText;
  const primaryLink = button.link || buttonLink;
  const secondaryText = secondaryButton.text || secondaryButtonText;
  const secondaryLink = secondaryButton.link || secondaryButtonLink;
  const {
    backgroundColor = 'var(--color-primary, #4a6741)',
    textColor = '#ffffff', backgroundImage = ''
  } = settings;

  const resolvedBg = resolveMediaServeUrl(backgroundImage, tenantSlug, apiBase) || backgroundImage;
  const sectionStyle = { backgroundImage: resolvedBg ? `url(${resolvedBg})` : undefined };
  const center = alignment === 'center';

  const makeBtn = (text, link, Comp) => {
    if (!text || !link) return null;
    if (isExt(link)) return <Comp as="a" href={link} target="_blank" rel="noopener noreferrer" $size="lg">{text}</Comp>;
    return <Comp as={Link} to={link} $size="lg">{text}</Comp>;
  };

  return (
    <Section $padding={cp} $bgColor={backgroundColor} $textColor={textColor} style={sectionStyle}>
      <Container style={{ textAlign: alignment }}>
        <Content $align={alignment}>
          {headline && <Headline>{headline}</Headline>}
          {subheadline && <Sub>{subheadline}</Sub>}
          {(primaryText || secondaryText) && (
            <Buttons $center={center}>
              {makeBtn(primaryText, primaryLink, BtnWhite)}
              {makeBtn(secondaryText, secondaryLink, BtnOutlineWhite)}
            </Buttons>
          )}
        </Content>
      </Container>
    </Section>
  );
};

export default CTABlock;
